import { render, staticRenderFns } from "./InplayMulti.vue?vue&type=template&id=261c7ec8&scoped=true"
import script from "./InplayMulti.vue?vue&type=script&lang=js"
export * from "./InplayMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c7ec8",
  null
  
)

export default component.exports